import React, { useState, useEffect, useRef } from "react";
import "./TopBar.css";
import { useTranslation } from "react-i18next";
import "../i18n";
import ThemeToggle from "./ThemeToggle";

const LANGUAGES = [
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "sw", flag: "🇰🇪", label: "Kiswahili" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
];

const TopBar = () => {
  const [activeLang, setActiveLang] = useState(null);
  const [langOpen, setLangOpen]     = useState(false);
  const langRef                     = useRef(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const saved = localStorage.getItem("solvio_lang") || "en";
    const found = LANGUAGES.find((l) => l.code === saved) || LANGUAGES[0];
    setActiveLang(found);
    i18n.changeLanguage(saved);
  }, [i18n]);

  useEffect(() => {
    const handler = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selectLang = (lang) => {
    setActiveLang(lang);
    setLangOpen(false);
    i18n.changeLanguage(lang.code);
    localStorage.setItem("solvio_lang", lang.code);
  };

  return (
    <div className="topbar">
      {/* Left — availability + tagline */}
      <div className="topbar-left">
        <span className="topbar-tagline">
          <span className="topbar-dot-wrapper">
            <span className="topbar-dot"></span>
            <span className="topbar-status">{t("topbar.available")}</span>
          </span>
          <span className="topbar-sep">·</span>
          {t("topbar.tagline")}
        </span>
      </div>

      {/* Right — language + theme only */}
      <div className="topbar-right">

        {/* Language Selector */}
        <div className="topbar-lang" ref={langRef}>
          <button
            className={`topbar-lang-trigger ${langOpen ? "topbar-lang-trigger--open" : ""}`}
            onClick={() => setLangOpen((v) => !v)}
            aria-label="Select language"
            aria-expanded={langOpen}
          >
            <span className="topbar-lang-flag">{activeLang?.flag}</span>
            <span className="topbar-lang-code">{activeLang?.code?.toUpperCase()}</span>
            <i className="fas fa-chevron-down topbar-lang-chevron"></i>
          </button>

          {langOpen && (
            <div className="topbar-lang-dropdown">
              {LANGUAGES.map((lang) => (
                <button
                  key={lang.code}
                  className={`topbar-lang-option ${activeLang?.code === lang.code ? "topbar-lang-option--active" : ""}`}
                  onClick={() => selectLang(lang)}
                >
                  <span className="topbar-lang-flag">{lang.flag}</span>
                  <span className="topbar-lang-label">{lang.label}</span>
                  {activeLang?.code === lang.code && (
                    <i className="fas fa-check topbar-lang-check"></i>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        <span className="topbar-divider"></span>

        {/* Theme Toggle */}
        <ThemeToggle />

      </div>
    </div>
  );
};

export default TopBar;